<script>
export default {
  name: "ConstructionStandardLinks",

  props: {
    constructionStandard: {
      type: Object,
      reqiured: true
    }
  }
}
</script>

<template>
  <v-list dense tyle="padding-top: 0px !important;" flat>
    <v-subheader>{{ constructionStandard.Description }}</v-subheader>

    <v-list-item :href="constructionStandard.pdfDownloadUrl" target="_blank">
      <v-list-item-icon>
        <v-icon dense>mdi-file-download-outline</v-icon>
      </v-list-item-icon>
      <v-list-item-title>download PDF</v-list-item-title>
    </v-list-item>

    <v-list-item v-if="constructionStandard.docxDownloadUrl" :href="constructionStandard.docxDownloadUrl"
                 target="_blank">
      <v-list-item-icon>
        <v-icon dense>mdi-file-download-outline</v-icon>
      </v-list-item-icon>
      <v-list-item-title>download DOCX</v-list-item-title>
    </v-list-item>

    <v-list-item v-if="constructionStandard.dwgDownloadUrl" :href="constructionStandard.dwgDownloadUrl" target="_blank">
      <v-list-item-icon>
        <v-icon dense>mdi-file-download-outline</v-icon>
      </v-list-item-icon>
      <v-list-item-title>download DWG</v-list-item-title>
    </v-list-item>

  </v-list>
</template>

<style scoped>
.v-list-item__icon {
  height: 24px;
  margin: 0px !important;
  margin-right: .5em !important;
}

.v-list--dense .v-list-item, .v-list-item--dense {
  min-height: 20px;
  height: 24px;
}

.v-list-item__title {
  font-weight: 400 !important;
}
</style>
